import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { routes } from "@shared/lib/react-router";
import { SupervisionAdminPage } from "./ui";

export const SupervisionAdminPageRoute = (
  ...rest: RouteObject[]
): RouteObject => {
  return {
    path: `${routes.supervision.adminSettings(":projectId", ":supervisionId")}`,
    element: createElement(SupervisionAdminPage),
    children: [...rest],
  };
};


